import { round } from "lodash";

export const FormatValueToLocaleString = (value) => {
    const data = (value || 0).toLocaleString(undefined, {  minimumFractionDigits: 2 });
    return data === '0.00' ? data : round(parseFloat(data.replace(/,/g, '')),2);
}

export const CapitalizeFirstLetter = (str) => {
    let capitalized = '';
    if (str) {
        capitalized = str.charAt(0).toUpperCase() + str.slice(1);
    }
    return capitalized;
}